export const BOOK_APPOINTMENT_POPUP_SLUG = 'book';
export const CONTACT_POPUP_SLUG = 'contact';
export const TRIAGE_POPUP_SLUG = 'triage';
export const ZOOMABLE_IMAGE_POPUP_SLUG = 'zoomable-image';
export const TIME_LINE_POPUP = 'timeline';
export const DIGITAL_SCREEN_IDLE_TIMEOUT_POPUP = 'digital-screen-idle-timeout-popup';
export const DIGITAL_SCREEN_EXTERNAL_LINK_POPUP = 'digital-screen-external-link-popup';
export const FEATURED_VIDEO_POPUP = 'featured-video';
export const EMBED_VIDEO_POPUP = 'embed-video';
